import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Böngésző automatikus scroll-visszaállításának kikapcsolása
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    // CSS smooth scroll ideiglenes felülírása, hogy azonnali legyen
    document.documentElement.style.scrollBehavior = 'auto';
    document.body.style.scrollBehavior = 'auto';

    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    // Smooth scroll visszaállítása rövid késleltetéssel
    const timer = setTimeout(() => {
      document.documentElement.style.scrollBehavior = '';
      document.body.style.scrollBehavior = '';
    }, 50);

    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
